/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SetRangeValuesRequest = {
    rangeZoneIds?: Array<number>;
    rangeGroupIds?: Array<number>;
    startingRangeNameId?: number;
    startingMidpoint: number;
    /**
     * Progression percent between consecutive ranges, e.g. 0.15 means +15%
     */
    progression: number;
    /**
     * Range spread as decimal: (max - min) / min, e.g. 0.5 yields min=80%, max=120% of mid
     */
    spread: number;
    roundingRule?: SetRangeValuesRequest.roundingRule;
};

export namespace SetRangeValuesRequest {

    export enum roundingRule {
        '_1' = 1,
        '_100' = 100,
        '_1000' = 1000,
        '_10000' = 10000,
        '_100000' = 100000,
    }


}

